import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const FALLBACK_DATE_FORMATS = ["DD/MM/YYYY HH:mm", "DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY"];

export function formatNewsDate(value: string | null | undefined, options?: { absoluteOnly?: boolean }): string {
  if (!value) return "";
  let parsed = dayjs(value);
  if (!parsed.isValid()) {
    parsed = dayjs(value, FALLBACK_DATE_FORMATS, true);
  }
  if (!parsed.isValid()) return "";

  if (options?.absoluteOnly) return parsed.format("MMM D, YYYY");

  const diffMs = dayjs().diff(parsed);
  const diffHours = Math.floor(diffMs / (60 * 60 * 1000));

  if (diffHours < 24) {
    if (diffMs < 60 * 1000) return "just now";
    if (diffHours < 1) {
      const diffMinutes = Math.max(1, Math.floor(diffMs / (60 * 1000)));
      return `${diffMinutes}m ago`;
    }
    return `${diffHours}h ago`;
  }

  return parsed.format("MMM D, YYYY");
}
